"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-like.tsx
var Like = function Like(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M0 20H4V8H0V20ZM22 9C22 7.9 21.1 7 20 7H13.69L14.64 2.43L14.67 2.11C14.67 1.7 14.5 1.32 14.23 1.05L13.17 0L6.59 6.59C6.22 6.95 6 7.45 6 8V18C6 19.1 6.9 20 8 20H17C17.83 20 18.54 19.5 18.84 18.78L21.86 11.73C21.95 11.5 22 11.26 22 11V9Z",
    fill: "currentColor"
  }));
};

var _default = Like;
exports.default = _default;